import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Product, ProductType} from '../types'

export const MaterialsProductsQueryKey = 'materialsProducts'

const materialsProductsQueryOptions = (plantCode: string) => ({
  queryKey: [MaterialsProductsQueryKey, plantCode] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<Record<ProductType, Product[]>>(
      `/plants/${plantCode}/materials/products`,
      {signal}
    )
    return response.data
  }
})

type Params<TReturn = Record<ProductType, Product[]>> = {
  plantCode: string
  options?: Omit<
    UseQueryOptions<Record<ProductType, Product[]>, AxiosError, TReturn>,
    'queryKey' | 'queryFn'
  >
}

export const useMaterialsProducts = <TReturn = Record<ProductType, Product[]>>({
  plantCode,
  options
}: Params<TReturn>) =>
  useQuery<Record<ProductType, Product[]>, AxiosError, TReturn>({
    ...materialsProductsQueryOptions(plantCode),
    ...options
  })
